<div class="navigation-shell" [class.navigation-shell--auth]="isAuthRoute">
  <p-sidebar
    *ngIf="!isAuthRoute"
    [(visible)]="visibleSidebar"
    [baseZIndex]="10000"
    [modal]="true"
    [fullScreen]="false"
    [blockScroll]="true"
    styleClass="app-sidebar-mobile"
  >
    <!-- Mobile menu -->
    <div class="sidebar-content">
      <div
        class="sidebar-header flex align-items-center justify-content-center"
      >
        <div class="sidebar-logo-wrap">
          <span class="sidebar-logo-mark"><img src="assets/vtt-logo.png" alt="Van Tonder Transport logo" /></span>
          <span class="sidebar-logo">VTT</span>
        </div>
      </div>

      <div class="sidebar-divider"></div>

      <ul *ngIf="user$ | async" class="sidebar-menu list-none p-0 m-0">
        <li *ngFor="let menuItem of sideMenuItems">
          <a
            pRipple
            #mobileRla="routerLinkActive"
            class="nav-item mobile-nav-item flex align-items-center cursor-pointer px-3 py-3 border-round transition-duration-150 transition-colors"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
            [routerLink]="[menuItem.routerLink]"
            [attr.aria-current]="mobileRla.isActive ? 'page' : null"
            (click)="hideSidebar()"
            style="text-decoration: none"
          >
            <i class="pi {{ menuItem.icon }}"></i>
            <span class="font-medium text-base">
              {{ menuItem.label }}
            </span>
          </a>
        </li>
      </ul>

      <div class="mt-auto">
        <div class="sidebar-divider"></div>

        <div *ngIf="user$ | async" class="sidebar-profile">
          <span class="sidebar-avatar">{{ profileInitials }}</span>
          <div class="sidebar-profile-copy">
            <span class="sidebar-profile-name">{{ profileName || 'Signed in' }}</span>
            <span class="sidebar-profile-role">{{ profileEmail }}</span>
          </div>
        </div>

        <a
          *ngIf="user$ | async"
          pRipple
          class="nav-item logout-btn flex align-items-center cursor-pointer px-3 py-3 border-round transition-duration-150 transition-colors"
          (click)="authenticationService.logout()"
          style="text-decoration: none"
        >
          <i class="pi pi-sign-out"></i>
          <span class="font-medium text-base">Sign Out</span>
        </a>
      </div>
    </div>
  </p-sidebar>

  <!-- Desktop menu -->
  <div
    class="static-sidebar"
    *ngIf="!isAuthRoute && !isMobile && (user$ | async)"
    [class.sidebar-collapsed]="isDesktopSidebarCollapsed"
  >
    <div class="sidebar-content">
      <div class="sidebar-header desktop-sidebar-header flex align-items-center">
        <div class="sidebar-logo-wrap">
          <span class="sidebar-logo-mark"><img src="assets/vtt-logo.png" alt="Van Tonder Transport logo" /></span>
          <span class="sidebar-logo">VTT</span>
        </div>
        <button
          type="button"
          class="desktop-sidebar-toggle p-button p-button-text p-button-rounded"
          pButton
          [icon]="
            isDesktopSidebarCollapsed
              ? 'pi pi-angle-right'
              : 'pi pi-angle-left'
          "
          [attr.aria-label]="
            isDesktopSidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'
          "
          (click)="toggleSidebar()"
        ></button>
      </div>

      <div class="sidebar-divider"></div>

      <ul *ngIf="user$ | async" class="sidebar-menu list-none p-0 m-0">
        <li *ngFor="let menuItem of sideMenuItems">
          <a
            pRipple
            #desktopRla="routerLinkActive"
            class="nav-item desktop-nav-item flex align-items-center cursor-pointer px-3 py-3 border-round transition-duration-150 transition-colors"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
            [routerLink]="[menuItem.routerLink]"
            [attr.aria-current]="desktopRla.isActive ? 'page' : null"
            (click)="hideSidebar()"
            style="text-decoration: none"
            [attr.aria-label]="menuItem.label"
            [pTooltip]="menuItem.label || ''"
            [tooltipDisabled]="!isDesktopSidebarCollapsed"
            tooltipPosition="right"
          >
            <i class="pi {{ menuItem.icon }}"></i>
            <span class="desktop-nav-label">{{ menuItem.label }}</span>
          </a>
        </li>
      </ul>

      <div class="mt-auto">
        <div class="sidebar-divider"></div>

        <div
          *ngIf="user$ | async"
          class="sidebar-profile"
          [pTooltip]="profileName + (profileRole ? ' — ' + profileRole : '')"
          [tooltipDisabled]="!isDesktopSidebarCollapsed"
          tooltipPosition="right"
        >
          <span class="sidebar-avatar">{{ profileInitials }}</span>
          <div class="sidebar-profile-copy desktop-nav-label">
            <span class="sidebar-profile-name">{{ profileName || 'Signed in' }}</span>
            <span class="sidebar-profile-role">{{ profileEmail }}</span>
          </div>
        </div>

        <a
          *ngIf="user$ | async"
          pRipple
          class="nav-item desktop-nav-item logout-btn flex align-items-center cursor-pointer px-3 py-3 border-round transition-duration-150 transition-colors"
          (click)="authenticationService.logout()"
          style="text-decoration: none"
          aria-label="Sign Out"
          tooltipPosition="right"
        >
          <i class="pi pi-sign-out"></i>
          <span class="desktop-nav-label">Sign Out</span>
        </a>
      </div>
    </div>
  </div>

  <div class="content-wrapper">
    <div
      class="mobile-top-bar"
      *ngIf="!isAuthRoute && isMobile && (user$ | async)"
    >
      <button
        type="button"
        class="mobile-menu-button"
        pButton
        icon="pi pi-bars"
        (click)="toggleSidebar()"
      ></button>
    </div>

    <div class="main-content">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
